import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import styles from './Breadcrumb.module.scss';
import classNames from 'classnames';
import Arrow from 'ui/icons/icon-chevron-right.svg';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';

export interface BreadcrumbProps {
	breadcrumbItems: Array<BreadcrumbItemProps>;
	background?: 'Primary';
}

interface BreadcrumbItemProps {
	url?: string;
	title: string;
}

export const UI_Breadcrumb = ({ breadcrumbItems, background }: BreadcrumbProps) => (
	<nav className={classNames(styles.Breadcrumb, background ? styles?.[`Breadcrumb___background${background}`] : '')}>
		<UI_Container width="Standard">
			<ul className={styles.Breadcrumb_wrapper}>
				{breadcrumbItems.map((breadcrumbItem: BreadcrumbItemProps, index) => {
					const isLastBreadcrumb = index === breadcrumbItems.length - 1;
					return (
						<li key={index} className={styles.Breadcrumb_item}>
							{isLastBreadcrumb ? (
								<p className={classNames(styles.Breadcrumb_url, styles.Breadcrumb_url___current)}>{breadcrumbItem.title}</p>
							) : (
								<UI_Link url={breadcrumbItem.url} className={styles.Breadcrumb_url}>
									{breadcrumbItem.title}
									<UI_Icon className={styles.Breadcrumb_icon} size="sm">
										<Arrow />
									</UI_Icon>
								</UI_Link>
							)}
						</li>
					);
				})}
			</ul>
		</UI_Container>
	</nav>
);
